<template>
  <div>
    <van-nav-bar
        :title="shoptitle"
        left-arrow
        @click-left="onClickLeft"
        >
        <template #right>
            <van-icon @click="gohome" style="font-size:21px" name="wap-home-o" />
        </template>
                </van-nav-bar>
    <div style="width:100%;height:50%">
      <img style="width:100%" :src="info.photo" alt="">
    </div>
    <div class="teacherName" style="display:flex">
          <div class="avatar">
            <van-image :src="info.photo" alt="" fit="cover" lazy-load radius="50%">
              <template v-slot:loading>
                <van-loading type="spinner" size="20" />
              </template>
            </van-image>
          </div>
          <div style="margin-left:10px">
            <div class="name">{{info.full_name}}</div>
            <div class="teachAge" style="color: #999;padding: 0px 3px;border: 1px solid #999;font-size: 12px;margin-top: 4px;">{{info.teach_age}}年教龄</div>
          </div>
        </div>
    <div class="content" v-html="info.content">
    </div>
    
    
      <div style="height:100px;background:#f2f2f2!important;display:flex;flex-direction:column;align-items:center;justify-content:center;">
          <span style="color:#606266;font-size:12px">京ICP备14010996号</span>
          <a href="https://www.weizaojiao.cn">
          <span style="color:#606266;font-size:12px;margin-top:8px">北京融入网络科技有限公司</span>
          </a>
    </div>
    
    
  </div>
</template>

<script>
export default {
    data(){
      return {
        info:[],
        id:sessionStorage.getItem("org"),
        obj1:{},
        shoptitle:''
      }
    },
    created(){
      this.shoptitle = sessionStorage.getItem('shop')
      this.obj1 = JSON.parse(sessionStorage.getItem('arr2'))
      console.log(this.id)
      this.$ajax('/App/PublicSphere/teacherDetail',{org_id:this.id,id:this.obj1.id}).then(res=>{
      this.info = res.data
    })
    },
    methods:{
      onClickLeft () {
            this.$router.back('/homedetail')
        },
        gohome(){
            this.$router.back('/homedetail')
      },
      jumper(){
        window.open('www.weizaojiao.cn')
      }
    }
}
</script>


<style lang="stylus" scoped>
@import "../static/css/global.styl"
.teacherDetailWrap
  height calc(100vh - 60px)
  overflow-y auto
  overflow-x hidden
  .van-loading
    height calc(100vh - 100px)
    width 100vw
    display flex
    align-items center
    justify-content center
  .topImgWrap
    width 100%
    height 350px
    overflow hidden
    display flex
    align-items center
    justify-content center
    .van-image
      width 100%
      height 100%
    img[lazy='error'],img[lazy='loading']
      width 50px
      height 50px
  .teacherName
    display flex
    align-items center
    padding 10px 14px
    .avatar
      width 80px
      height 80px
      overflow hidden
      display flex
      align-items center
      justify-content center
      margin -40px 10px 0 0
      .van-image
        border 2px solid #fff
        width 100%
        height 100%
    .name
      font-weight 700
      margin-bottom 6px
    .teachAge
      font-size 10px
      line-height 12px
      color #999
      padding 1px 4px
      border 1px solid #999
  .brief
    padding 0 10px
    & >>> iframe
      width 100%
      height auto
    & >>> img
      width 100%
      max-width 100%
      height auto
    & >>> p
      max-width 100%
      word-wrap break-word
    & >>> div
      max-width 100%
      word-wrap break-word
.van-image
    overflow: hidden;
    border-radius: 50%;
    width: 90px;
    height: 90px;
    margin-top: -40px;
    border: 3px solid #fff;
    margin-left: 15px;
</style>
<style lang="less" scoped>
/deep/ .van-nav-bar .van-icon{
    color: #777!important;
    font-size: 20px;
}
/deep/ .van-nav-bar__text{
    color:#777!important
}
</style>
<style lang="less">
.content{
  overflow: hidden;
}
.content img{
  max-width:100%!important;
}
</style>